import React, { useContext } from "react";
import { Icon } from "@mdi/react";
import { mdiCircle } from "@mdi/js";
import styles from "./styles.scss";
import { currentSport } from "src/services/ApolloService";
import { SubscriptionContext } from "src/services/SubscriptionService";
import { useFreeTrialClaimed } from "src/services/UserService";
import { useReactiveVar } from "@apollo/client";
export interface AdEventsProps {
  valueEvents: number;
  sharpEvents: number;
  message: string;
}

const FreeTrialBanner = ({ title, adEvents }: { title: string; adEvents: AdEventsProps }) => {
  const ctx = useContext(SubscriptionContext);
  const league = useReactiveVar(currentSport);
  const openPricing = () => {
    ctx.togglePricingModal({
      source: "Game Free Trial Banner",
    });
  };
  const trialClaimed = useFreeTrialClaimed();
  return (
    <div
      className="game-table-paywall"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(0, 33, 77, 0.7), rgba(0, 33, 77, 0.7)),url(/images-league-paywall/${league?.key}.jpg)`,
      }}
    >
      <div className="game-table-paywall-title">{title}</div>
      <div className="game-table-paywall-subtitle">
        {adEvents?.valueEvents > 2 && <span>{adEvents.valueEvents} Best Bets</span>}
        {adEvents?.sharpEvents > 2 && (
          <span>
            <Icon color="#14F2B3" path={mdiCircle} size="8px" style={{ margin: "0px 10px" }} /> {adEvents.sharpEvents}{" "}
            Games Pro Bettors Love
          </span>
        )}
      </div>
      <div className="game-table-paywall-free-trial" onClick={openPricing}>
        {trialClaimed ? "Upgrade Now" : "Start Free Trial"}
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default FreeTrialBanner;
